import assets from '../../apis/assets.api';
export const bulkCurveOperation = (curveOps) => assets.post('/assets/bulk', curveOps);
